function setText(element, text){
	element.innerHTML=text;
}
export default setText;